// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-home .jumbotron{border-radius:0px 0px 6px 6px;margin-top:-10px;background-color:#eee}.container-home img{max-height:200px;margin:52px 0 52px 100px}@media (max-width: 1100px){.container-home img{max-height:200px;margin:2px 0 2px 50px}}\n", ""]);
// Exports
module.exports = exports;
